import * as React from 'react';

export default () => <img src={require('../images/logo.png')} />;
